<div class="unh-button-old"
  [ngClass]="{'block' : !translucid}">
  <button>
    <ng-content></ng-content>
  </button>
</div>
